import { useState, useEffect } from 'react';

const cache: Record<string, string> = {};

export function useTikTokThumbnail(tiktokUrl: string) {
  const [thumbnailUrl, setThumbnailUrl] = useState<string>(cache[tiktokUrl] || '');
  const [loading, setLoading] = useState(!cache[tiktokUrl]);

  useEffect(() => {
    if (!tiktokUrl) {
      setLoading(false);
      return;
    }
    if (cache[tiktokUrl]) {
      setThumbnailUrl(cache[tiktokUrl]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    async function fetchThumbnail() {
      try {
        const oembedUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(tiktokUrl)}`;
        const res = await fetch(oembedUrl);
        if (!res.ok) throw new Error('oembed fetch failed');
        const data = await res.json();
        if (!cancelled && data.thumbnail_url) {
          cache[tiktokUrl] = data.thumbnail_url;
          setThumbnailUrl(data.thumbnail_url);
        }
      } catch {
        // fallback: keep empty
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchThumbnail();
    return () => { cancelled = true; };
  }, [tiktokUrl]);

  return { thumbnailUrl, loading };
}
